import { createApp } from "vue";
import App from "./App.vue";
import router from "./router/index";
import "@fortawesome/fontawesome-free/css/all.css";
import "./assets/styles/common.scss";
import { ToastService } from "./services/ToastService";

const setFavicon = () => {
  const favicon =
    document.querySelector('link[rel="icon"]') ||
    document.createElement("link");
  favicon.type = "image/x-icon";
  favicon.rel = "icon";
  favicon.href = "/favicon.ico"; // Path relative to domain root
  if (!document.querySelector('link[rel="icon"]')) {
    document.head.appendChild(favicon);
  }
};

// Set favicon immediately
setFavicon();

// Thêm vào global để có thể truy cập từ mọi nơi
window.ToastService = ToastService;

const app = createApp(App);
app.use(router);
app.mount("#app");
